import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import OrdersInvoicesGetters from './getters';
import OrdersInvoicesMutations from './mutations';
import OrdersInvoicesState from './state';
import { OrdersService } from '../../../services';

const ordersService = new OrdersService();

export default class OrdersInvoicesActions extends Actions<
  OrdersInvoicesState,
  OrdersInvoicesGetters,
  OrdersInvoicesMutations,
  OrdersInvoicesActions
> {
  // получение данных о счетах по заказам

  async get_orders_invoices() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.orders_invoices_filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_ORDERS_INVOICES(true);
      const { data, meta } = await ordersService.get_orders_invoices(payload);

      this.mutations.SET_ORDERS_INVOICES(data.items);
      this.mutations.SET_ORDERS_INVOICES_ORGANIZATIONS(data.organizations);
      this.mutations.SET_ALLOWED_DATES_ORDERS_INVOICES(data.dates);
      this.mutations.SET_USERS(data.users);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_ORDERS_INVOICES(false);
    }
  }

  async read(id: number | string) {
    try {
      const { code } = await ordersService.read(id);

      return code;
    } catch (error) {
      console.error(error);
    }
  }
}
